import {Button} from "@mui/material"
import Grid from "@mui/material/Grid"
import {ErrorIcon} from "@indebted/assets"
import {paletteColors} from "@indebted/theme"
import {useNavigate} from "react-router-dom"

import {ColoredTypographyWithBottomMargin} from "./styles"

const ChargeInitiateFailedPage = ({
	I18n,
}: {
	I18n: {
		FailedInstalmentGeneralErrorTitle: string
		FailedInstalmentGeneralErrorSubtitle: string
		FailedInstalmentGeneralErrorButtonText: string
	}
}) => {
	const navigate = useNavigate()

	return (
		<Grid container direction="column" alignItems="center" justifyContent="center">
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{margin: "30px 0px"}}>
				<ErrorIcon />
			</Grid>
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "10px"}}>
				<ColoredTypographyWithBottomMargin
					variant="h5"
					color={paletteColors.stratosLight2}
					align="center"
					style={{padding: "0 64px", fontWeight: 700, lineHeight: "28px"}}
				>
					{I18n.FailedInstalmentGeneralErrorTitle}
				</ColoredTypographyWithBottomMargin>
			</Grid>
			<Grid container direction="row" alignItems="center" justifyContent="center" style={{marginBottom: "34px"}}>
				<ColoredTypographyWithBottomMargin
					variant="subtitle1"
					color={paletteColors.stratos}
					align="center"
					style={{padding: "0 64px", lineHeight: "22px"}}
				>
					{I18n.FailedInstalmentGeneralErrorSubtitle}
				</ColoredTypographyWithBottomMargin>
			</Grid>

			<Button
				style={{borderRadius: "35px", padding: "6px 30px", marginTop: "10px"}}
				type="button"
				onClick={() => {
					navigate("./")
					navigate(0)
				}}
				variant="contained"
			>
				{I18n.FailedInstalmentGeneralErrorButtonText}
			</Button>
		</Grid>
	)
}

export {ChargeInitiateFailedPage}
